export default __webpack_public_path__ + "images/8Z.ad284e3.png";